module.exports = __webpack_public_path__ + "img/old_2.cd46d8a0.jpg";